import React, { useEffect, useState } from "react";
import { FormParser, PopupModal } from "../Components";
import Masters from "../Components/masters.json"
import axiosConfig from "../Service/axiosConfig"
import { useParams, useNavigate } from "react-router-dom";
import { BiArrowBack } from "react-icons/bi";
import { Requirementcontsnt } from "./Requirementcontsnt";
import { MdOutlineEdit } from "react-icons/md";
const AuditionRequirement = ({ Code }) => {
    let { id } = useParams();
    const navigate = useNavigate();
    const [readOnly, setReadOnly] = useState(true);
    const [popupType, setpopupType] = useState("");
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null);
    const [Data, SetData] = useState({});
    const [Message, setMessage] = useState("")
    const GetData = () => {
        setLoading(true)
        axiosConfig.get(`/accounts/audition-requirements/${id}/`).then(res => {
            console.log(res.data)
            SetData({
                ...res.data,
            })
            setLoading(false)
        }).catch(error => {
            console.log(error)
        })
    }
    const formSubmit = (formData) => {
        const OrderTopost = {
            approval_status: formData?.approval_status,
            approval_message: formData?.approval_message ? formData.approval_message : "",
        };
        if (String(formData?.approval_status || "").toLowerCase() === "approved") {
            OrderTopost.requirement_status = formData?.requirement_status;
        }
        axiosConfig.patch(`/accounts/audition-requirements/${Data.id}/`, OrderTopost).then(res => {
            console.log(res)
            GetData()
            setMessage("Requirement Updated SuccessFully!")
            setpopupType("success");
        }).catch(error => {
            console.log(error.response)
        })
    };
    const handleNavigate = (link, type) => {
        if (type === "profile") {
            navigate(`/dashboard/users/${link}/edit`)
        }
        if (type === "back") {
            navigate(-1)
            // navigate(`/dashboard/masters/Audition-requirements/`)
        }
        if (type === "edit") {
            navigate(`/dashboard/masters/Auditions/${link}/edit`)
        }
    }
    useEffect(() => {
        GetData()
    }, [])
    return (
        <>
            
                <div className="main-container">
                    <div className="content-area">
                        <div className="client-options">
                            <BiArrowBack size={24} onClick={() => handleNavigate("", "back")} className="option-icon" />
                        </div>
                        <div className="requirement-info">
                            <div className="client-info">
                                <div className="contact-detile">
                                    Id : <div className="data-text">AD{Data.audition?.id}</div>
                                </div>
                                <div className="contact-detile">
                                    Banner Name : <div className="data-text">{Data.audition?.banner_name}</div>
                                </div>
                                <div className="contact-detile">
                                    Contact Name : <div className="data-text">{Data.audition?.contact_name}</div>
                                </div>
                                <div className="contact-detile">
                                    Contact Designation Name : <div className="data-text">{Data.audition?.contact_designation}</div>
                                </div>
                                <div className="contact-detile">
                                    Contact Mobile No : <a href={`tel:+${Data.audition?.contact_mobile_no}`} className="data-text">{Data.audition?.contact_mobile_no}</a>
                                </div>
                                <div className="contact-detile">
                                    Profile Details : <div className="data-text">{Data?.audition?.profile?.first_name} ({Data?.audition?.profile?.hcc_id})</div>
                                </div>
                                <div className="contact-detile">
                                    Start Date : <div className="data-text">{Data.audition?.start_date}</div>
                                </div>
                            </div>
                            <div className="client-info client-edit">
                                <div>
                                    <div className="contact-detile">
                                        Project Type : <div className="data-text">{Data.audition?.project_type}</div>
                                    </div>
                                    <div className="contact-detile">
                                        Project Title : <div className="data-text">{Data.audition?.project_title}</div>
                                    </div>
                                    <div className="contact-detile">
                                        Producer Name : <div className="data-text">{Data.audition?.producer_name}</div>
                                    </div>
                                    <div className="contact-detile">
                                        Director Name : <div className="data-text">{Data.audition?.director_name}</div>
                                    </div>
                                    {Data.audition?.hero && <div className="contact-detile">
                                        Hero Name : <div className="data-text">{Data.audition?.hero}</div>
                                    </div>}
                                    <div className="contact-detile">
                                        Zoner : <div className="data-text">{Data.audition?.zoner}</div>
                                    </div>
                                    <div className="contact-detile">
                                        platform : <div className="data-text">{Data.audition?.platform}</div>
                                    </div>
                                    <div className="contact-detile">
                                        budget : <div className="data-text">{Data?.audition?.budget}</div>
                                    </div>
                                </div>
                                <div>
                                    <button className="btn btn-primary" onClick={() => handleNavigate(Data?.audition?.id, "edit")} ><MdOutlineEdit size={24} className="option-icon" /> Audition</button>
                                </div>
                            </div>
                        </div>
                        <div>
                            {Data.audition?.description && <div className="contact-detile">
                                Description:<div className="data-text">{Data.audition?.description}</div>
                            </div>}
                        </div>
                        <div className="client-form">
                            <div className="projects-container requirement-detail-container">
                                {Data && (
                                    <Requirementcontsnt
                                        Data={Data}
                                        GetData={GetData}
                                        statusForm={(
                                            <div className="requirement-status-panel">
                                                <div className="d-flex flex-wrap gap-4 mb-3">
                                                    <div>
                                                        <div className="text-muted" style={{ fontSize: 11, textTransform: "uppercase" }}>Created</div>
                                                        <div>
                                                            {Data?.cdate || Data?.created_at
                                                                ? new Date(Data.cdate || Data.created_at).toLocaleString("en-IN", {
                                                                    year: "numeric",
                                                                    month: "short",
                                                                    day: "2-digit",
                                                                    hour: "2-digit",
                                                                    minute: "2-digit",
                                                                })
                                                                : "--"}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div className="text-muted" style={{ fontSize: 11, textTransform: "uppercase" }}>Updated</div>
                                                        <div>
                                                            {Data?.mdate
                                                                ? new Date(Data.mdate).toLocaleString("en-IN", {
                                                                    year: "numeric",
                                                                    month: "short",
                                                                    day: "2-digit",
                                                                    hour: "2-digit",
                                                                    minute: "2-digit",
                                                                })
                                                                : "--"}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div className="text-muted" style={{ fontSize: 11, textTransform: "uppercase" }}>Approval</div>
                                                        <div><b>{Data?.approval_status || "--"}</b></div>
                                                    </div>
                                                    {String(Data?.approval_status || "").toLowerCase() === "approved" && (
                                                        <div>
                                                            <div className="text-muted" style={{ fontSize: 11, textTransform: "uppercase" }}>Requirement Status</div>
                                                            <div><b>{Data?.requirement_status || "--"}</b></div>
                                                        </div>
                                                    )}
                                                </div>
                                                {Data?.approval_status === "rejected" ? (
                                                    <div className="mb-3">
                                                        <div className="text-muted" style={{ fontSize: 11, textTransform: "uppercase" }}>Rejection reason</div>
                                                        <div style={{ color: "#b91c1c" }}>{Data?.rejected_message || Data?.approval_message || "--"}</div>
                                                    </div>
                                                ) : (Data?.rejected_message || Data?.approval_message) ? (
                                                    <div className="mb-3">
                                                        <div className="text-muted" style={{ fontSize: 11, textTransform: "uppercase" }}>Approval message</div>
                                                        <div>{Data.rejected_message || Data.approval_message}</div>
                                                    </div>
                                                ) : null}
                                                <FormParser modelObject={Masters.RequirementStatus} formData={Data} formSubmit={formSubmit} error={Error} readOnly={readOnly} setReadOnly={setReadOnly} />
                                            </div>
                                        )}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {popupType != "" &&
                    <PopupModal popupType={popupType} Navigation="" setpopupType={setpopupType} Message={Message} error={error} />
                }
            
        </>
    )

}
export { AuditionRequirement }